import { StrictMode, lazy, Suspense } from 'react'
//, { lazy, Suspense }
import { createRoot } from 'react-dom/client'
import { RouterProvider, createHashRouter } from "react-router-dom";
import FirstStep from "./modules/pages/FirstStep";
import SecondStep from './modules/pages/SecondStep';
import DataService from "./modules/services/DataService";
// import reportWebVitals from "./reportWebVitals";
import './assets/main.scss';
import { ThemeProvider, createTheme } from '@mui/material';
// const MyComponent = lazy(() => import('./MyComponent'));
(new DataService()).saveQuestions([]);
(new DataService()).saveUserInfo();

const router = createHashRouter([
  {
    path: "/",
    element: < FirstStep />,
    // lazy: () => import("./modules/pages/first-step"),
  }, {
    path: "/results",
    element: < SecondStep />,
  },
]);

const theme = createTheme({
  palette: {
    mode: 'light',
    background: {
      paper: '#F8F8F8',
      default: '#fff',
    },
    primary: {
      main: '#03AEEF',
    },
    text: {
      secondary: '#717171',
      primary: '#585858',
    },
    info: {
      main: '#03AEEF'
    },
    action: {
      active: '#03AEEF',
    },
    grey: {
      "400": '#CCCCCC',
      "900": '#585858'
    },
    error: {
      main: '#FF5656'
    }
  },
  spacing: 10,
  typography: {
    h1: {
      fontWeight: 'bold',
      fontSize: '2rem',
      color: '#585858',
    },
    h2: {
      fontWeight: '700',
      fontSize: '1.5rem',
      color: '#585858',
    },
    htmlFontSize: 18,
    fontSize: 18,
    fontWeightBold: 900
  },
  components: {
    MuiAccordionSummary: {
      styleOverrides: {
        expanded: ({ theme }) =>
          theme.unstable_sx({
            mt: 0,
            mb: 0,
            // borderRadius: 1,
          }),
      }
    }
  }
});

createRoot(document.getElementById("app")!).render(
  <StrictMode>
    {/* <Suspense fallback={<div>Loading...</div>}>
      <MyComponent />
    </Suspense> */}
    <ThemeProvider theme={theme}>
      <RouterProvider router={router} />
    </ThemeProvider>
  </StrictMode>
)

